import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { TranslateModule } from '@ngx-translate/core'
import * as ActivityFeedPostsActions from 'libs/gb-front/activity-feed/data-access/src/lib/+state/activity-feed-posts.actions'
import { ActivityFeedPostsFacade } from 'libs/gb-front/activity-feed/data-access/src/lib/+state/activity-feed-posts.facade'
import * as AuthActions from 'libs/gb-front/auth/data-access/src/lib/+state/auth.actions'
import { AuthFacade } from 'libs/gb-front/auth/data-access/src/lib/+state/auth.facade'
import { ItemEntity } from 'libs/gb-front/selected-item/data-access/src/lib/+state/selected-item.models'
import { SelectedProfileFacade } from 'libs/gb-front/selected-profile/data-access/src/lib/+state/selected-profile.facade'
import { ProfileEntity } from 'libs/gb-front/selected-profile/data-access/src/lib/+state/selected-profile.models'
import { GbFrontDialogService } from 'libs/gb-front/shared/util/src/lib/gb-front-dialog-service/gb-front-dialog.service'
import { GbMessageDialogComponent } from 'libs/gb-front/shared/util/src/lib/gb-message-dialog/gb-message-dialog.component'
import { map } from 'rxjs'

@Component({
  selector: 'gb-activity-feed-post-create',
  templateUrl: './gb-activity-feed-post-create.component.html',
  styleUrls: ['./gb-activity-feed-post-create.component.scss'],
  imports: [
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    CommonModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class GbActivityFeedPostCreateComponent {
  @Input() item?: ItemEntity
  @Input() parentPost?: string
  @Output() cancel = new EventEmitter<void>()

  maxChar = 128
  messageForm: FormGroup = new FormGroup({
    message: new FormControl('', [Validators.required]),
  })

  selectedProfile$ = this.selectedProfileFacade.selectedProfile$
  getSubmitting$ = this.activityFeedPostsFacade.getSubmitting$
  counterValue$? = this.messageForm.get('message')?.valueChanges.pipe(map((value) => (value ? value.length : 0)))

  get placeholder(): string {
    return this.parentPost ? 'ACTIVITY_FEED.CREATE_POST.REPLY_PLACEHOLDER' : 'ACTIVITY_FEED.CREATE_POST.PLACEHOLDER'
  }

  constructor(
    private activityFeedPostsFacade: ActivityFeedPostsFacade,
    private selectedProfileFacade: SelectedProfileFacade,
    private authFacade: AuthFacade,
    private gbFrontDialogService: GbFrontDialogService,
  ) {}

  onSubmit(selectedProfile: ProfileEntity | null | undefined): void {
    const action = ActivityFeedPostsActions.startPostProcess({
      message: this.messageForm.value.message,
      parentPost: this.parentPost,
      item: this.item,
      onSuccess: () => this.onPostSuccess(),
    })

    if (!selectedProfile) {
      this.authFacade.dispatch(AuthActions.openRegisterLoginDialog({ checkProfile: false, onSuccess: () => action }))
    } else {
      this.activityFeedPostsFacade.dispatch(action)
    }
  }

  onPostSuccess(): void {
    this.messageForm.reset()
    if (this.item) {
      this.gbFrontDialogService.closeDialog(GbMessageDialogComponent)
    }
  }

  cancelReply(): void {
    this.cancel.emit()
  }
}
